import React, { lazy } from 'react';
export function TransformationSection() {
  return <section className="w-full py-20 md:py-28 px-6 bg-dark" data-id="element-197">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-16" data-id="element-198">
        <div className="flex-1 text-center md:text-left order-2 md:order-1" data-id="element-199">
          <h2 className="font-playfair text-4xl md:text-5xl lg:text-6xl text-white leading-tight" data-id="element-200">
            Imagina cómo se sentiría tu vida <br className="hidden lg:block" data-id="element-201" />
            <span className="text-warmgold italic" data-id="element-202">sin ese peso.</span>
          </h2>
        </div>
        <div className="flex-1 w-full flex justify-center md:justify-end order-1 md:order-2" data-id="element-203">
          <img src="https://cdn.magicpatterns.com/uploads/aakdzgg5DevCGkb8pt5zUS/810d787f-3730-4a10-9b45-8e96d55e3c13.png" alt="Mariposa transformación" loading="lazy" className="w-full max-w-md rounded-2xl shadow-2xl shadow-warmgold/10 object-cover aspect-[3/4]" data-id="element-204" />
        </div>
      </div>
    </section>;
}